module.exports = __webpack_public_path__ + "static/media/midwestjs-lighthouse-optimized.f8d7ac0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/98-demo/images/midwestjs-lighthouse-optimized.jpg
// module id = 976
// module chunks = 0